import { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const CreateResources = () => {
  const [resource, setResource] = useState("");
  const [resourceList, setResourceList] = useState([]);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(
        "https://tnbx7rvcbc.us-east-1.awsapprunner.com/articles/createcategory",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ name: resource }),
        }
      );

      const data = await res.json();

      if (res.ok) {
        setMessage("Successfully added");
        fetchPosts();
      } else {
        setMessage(data.message || "Failed to submit data.");
      }
    } catch (err) {
      console.error(err);
      setMessage("An error occurred.");
    }
  };

  const fetchPosts = () => {
    fetch("https://tnbx7rvcbc.us-east-1.awsapprunner.com/articles/categories")
      .then((response) => response.json())
      .then((data) => {
        setResourceList(data.data);
        console.log(data, "resosurs data");
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
      });
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  const handleDelete = async (resID) => {
    try {
      const response = await fetch(
        `https://tnbx7rvcbc.us-east-1.awsapprunner.com/articles/${resID}`,
        {
          method: "DELETE",
        }
      );

      if (response.ok) {
        console.log("Item deleted successfully");
        fetchPosts();
        // Optionally refresh the list or update state
      } else {
        console.error("Failed to delete post");
      }
    } catch (error) {
      console.error("Error deleting post:", error);
    }
  };

  const sortedData = resourceList.sort((a, b) => {
    const getLetterNumber = (item) => {
      const match = item.name.match(/Letter (\d+)/);
      return match ? parseInt(match[1], 10) : 0;
    };

    return getLetterNumber(a) - getLetterNumber(b);
  });

  return (
    <div className="blog_dash_wrapper">
      <h2>Add Resource</h2>
      <form onSubmit={handleSubmit}>
        <div className="blog_input">
          <label>Resource Name</label>
          <input
            type="text"
            value={resource}
            onChange={(e) => setResource(e.target.value)}
            required
          />
        </div>
        <button className="blog_submit" type="submit">
          Add Resource
        </button>

        {message && <p>{message}</p>}
      </form>
      <h2 style={{ marginTop: "50px" }}>Resource List</h2>
      <div className="dash_blog_list_wrapper">
        {sortedData?.map((data, index) => {
          return (
            <div className="list_item" key={index}>
              <div className="list_content">
                <div className="content">
                  <h2>{data.name}</h2>
                </div>
              </div>
              <div className="list_action">
                <button onClick={() => handleDelete(data._id)}>Delete</button>
              </div>
            </div>
          );
        })}
      </div>
      <ul className="resource_list">
        {/* <li>Resource 1</li>
        <li>Resource 2</li>
        <li>Resource 3</li>
        <li>Resource 4</li> */}
      </ul>
    </div>
  );
};

export default CreateResources;
